module.exports = __webpack_public_path__ + "img/kort-10.946a7497.jpg";